import React from 'react';
import { Guid } from '@Shared.Angular/@types/guid';
import { DeleteEntityTypes } from '@Shared.Angular/flowingly.services/flowingly.constants';
import IGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/group/groupDetail';
import IUserBasicInfo from '@Shared.Angular/@types/core/contracts/queryModel/user/UserBasicInfo';
import { RunnerSetupDeleteSearchUser } from './RunnerSetupDeleteSearchUser';
import { RunnerSetupDeleteSearchTeam } from './RunnerSetupDeleteSearchTeam';

export interface IEntityToDelete {
  email: string;
  fullName: string;
  id: Guid;
  isManager?: boolean;
}

interface IActorSelection {
  actor?: Guid;
  manager?: Guid;
  customdatabaseactor?: Guid;
  categoryApprover?: Guid;
  stepTaskUserId?: Guid;
}

type Props = {
  entityToDelete: IEntityToDelete | IGroupDetail;
  entityName: string;
  entityType: DeleteEntityTypes;
  teams?: IGroupDetail[];
  users?: IUserBasicInfo[];
  managers?: IUserBasicInfo[];
  reassignActorRequired: boolean;
  onActorChosen: (actors: IActorSelection) => void;
  reassignCustomDatabaseRequired: boolean;
  reassignCategoryApproverRequired: boolean;
  reassignStepTasksRequired: boolean;
};

export const RunnerSetupDeleteSearch = ({
  entityToDelete,
  entityName,
  entityType,
  teams = [],
  reassignActorRequired,
  onActorChosen,
  reassignCustomDatabaseRequired,
  reassignCategoryApproverRequired,
  reassignStepTasksRequired
}: Props) => {
  if (entityType === DeleteEntityTypes.userEntityType) {
    return (
      <RunnerSetupDeleteSearchUser
        entityToDelete={entityToDelete as IEntityToDelete}
        entityName={entityName}
        teams={teams}
        reassignActorRequired={reassignActorRequired}
        onActorChosen={onActorChosen}
        reassignCustomDatabaseRequired={reassignCustomDatabaseRequired}
        reassignCategoryApproverRequired={reassignCategoryApproverRequired}
        reassignStepTasksRequired={reassignStepTasksRequired}
      />
    );
  }

  if (entityType === DeleteEntityTypes.teamEntityType) {
    return (
      <RunnerSetupDeleteSearchTeam
        entityToDelete={entityToDelete as IGroupDetail}
        entityName={entityName}
        teams={teams}
        onActorChosen={onActorChosen}
      />
    );
  }

  return null;
};
